<template lang="pug">
    title-modal-layout.creators-list-modal(v-if="creators" v-bind="$attrs" :title="title" :disableButtons="true" :class="theClass" ref="modal")
        template(v-slot:section)
            creators-list-control(v-if="hasCreators" :creators="creators" @goToProfile="goToProfile")
                template(v-slot:item-decorator="{creator}")
                    slot(name="list-item-decorator" :creator="creator")
            div.creators-list-modal__empty-message(v-else) {{ emptyMessage }}
</template>

<script>
export default {
    name: 'creators-list-modal',

    props: {
        title: {
            type: String,
            required: true,
        },
        creators: {
            validator: v => !v || Array.isArray(v),
            required: true,
            
        },
        emptyMessage: {
            type: String,
            required: true,
        },
    },

    computed: {
        hasCreators() {
            return this.creators && this.creators.length
        },

        theClass() {
            return {
                'creators-list-modal--not-empty': this.hasCreators,
            }
        },
    },

    methods: {
        goToProfile() {
            this.$refs.modal.close()
        },
    },
}
</script>
